import { useCallback } from "react";

import useOpenLearnGuide from "components/AssistantPanel/Learn/useOpenLearnGuide";
import useMissionsProgressData from "views/Account/MissionControl/MissionsProgress/useData";

const useLaunchPadLearnResumeActiveMission = () => {
  const { nextObjective } = useMissionsProgressData();
  const openLearnGuide = useOpenLearnGuide();

  const activeMission = nextObjective?.isInProgress ? nextObjective : undefined;

  const handleContinue = useCallback(() => {
    if (!activeMission) return;
    openLearnGuide(activeMission.groupId);
  }, [activeMission, openLearnGuide]);

  return { activeMission, handleContinue };
};

export default useLaunchPadLearnResumeActiveMission;
